import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import Table from 'components/Table';
import AddIcon from 'assets/svgs/actions/add.svg';
import EditIcon from 'assets/svgs/actions/edit-small.svg';
import {normalizePageFolderLanguages} from 'enums';
import AddFolder from './add';
import EditFolder from './Edit';

const Pages = () => {
  const [create, setCreate] = useState(false);
  const [edit, setEdit] = useState({
    isOpen: false,
    selected: null,
  });

  const columns = [
    {
      bodyClass: 'bg-white',
      headerName: 'Page name',
      field: 'title',
      width: '200',
      left: 0,
    },
    {
      headcolumClass: 'text-center',
      bodyClass: 'bg-white text-center',
      headerName: 'Domain',
      render: (row) => `${row.subDomain}.jidipi.com`,
      width: '200',
      left: 200,
    },
    {
      headcolumClass: 'text-center',
      bodyClass: 'bg-white text-center',
      headerName: 'Page Type',
      field: 'pageType',
      width: '200',
      left: 200,
    },
    {
      bodyClass: 'bg-white text-center',
      headerName: 'Languages',
      render: (row) =>
        normalizePageFolderLanguages(row.languages)
          .map((language) => language.code)
          .join(', '),
      width: '200',
    },
    {
      headcolumClass: 'text-center',
      headerName: 'Edit',
      render: (row) => (
        <div className="d-flex link-icon justify-content-around">
          <a
            href="#test"
            onClick={(e) => {
              e.preventDefault();

              setEdit({isOpen: true, selected: row});
              setTimeout(() => {
                window.scrollTo(0, 0);
              }, 500);
            }}
          >
            <img src={EditIcon} alt="Edit" title="Edit" />
          </a>
        </div>
      ),
      width: '100',
    },
  ];

  const data = useSelector((state) => state.folders.folders);

  return (
    <div>
      <ul className="d-flex p-0 list-tab-btn m-0">
        <li>
          <button
            type="button"
            className="add-btn bg-gray4 btn no-radius add-new-blog"
            onClick={() => setCreate(!create)}
          >
            <img src={AddIcon} className="mr-2" width="12" alt="" /> Add
          </button>
        </li>
      </ul>
      {create && <AddFolder onCancel={() => setCreate(false)} />}

      {edit.isOpen && edit.selected && (
        <EditFolder
          onCancel={() => setEdit({isOpen: false, selected: null})}
          selected={edit.selected}
        />
      )}

      <div className="dashboard-list  mt-4 ">
        <div className="statics-list table-responsive">
          <Table
            columns={columns}
            data={data}
            className="table-bordered white-td"
            headerClass="bg-gray4"
          />
        </div>
      </div>
    </div>
  );
};

export default Pages;
